import { render, staticRenderFns } from "./EditJournalEntryDialog.vue?vue&type=template&id=70ed187f"
import script from "./EditJournalEntryDialog.vue?vue&type=script&lang=js"
export * from "./EditJournalEntryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports